import { Component, OnDestroy } from '@angular/core';
import { BeanDialogComponentBase, IDialogInput } from 'bean-kendo-dialog';
import { Observable, of, Subscription } from 'rxjs';
import { ConstantHelper } from '@veritas-shared/helpers/constant.helper';
import { PayloadType } from '@veritas-shared/models/entities/payload-type';
import { WasteType } from '@veritas-shared/models/entities/waste-type';
import { VeritasMessage } from '../../models/dumpster-event-detail';
import { DumpsterService } from '../../services/dumpster.service';
import { SelectEvent } from '@progress/kendo-angular-layout';

@Component({
  selector: 'app-dumpster-event-detail-dialog',
  templateUrl: './dumpster-event-detail-dialog.component.html',
  styleUrls: ['./dumpster-event-detail-dialog.component.scss']
})
export class DumpsterEventDetailDialogComponent extends BeanDialogComponentBase<DumpsterEventDetailDialogInput> implements OnDestroy {
  public event: VeritasMessage = {} as VeritasMessage;
  public eventSource?: VeritasMessage;

  private eventDetail$ = new Subscription();

  constructor(
    private dumpsterService: DumpsterService,
    public constantHelper: ConstantHelper,
  ) {
    super();
  }

  ngOnDestroy(): void {
    this.eventDetail$.unsubscribe();
  }

  ngAfterViewInitCallback(): void {
    this.event = this.data.event;
  }

  cancel = (e: any): boolean => true;
  back = (e: any): boolean => true;
  save = (e: any): Observable<any> => of(false);

  public setTabClick = (event: SelectEvent): void => {
    if (event?.index !== 1 || Boolean(this.eventSource)) return;
    this.setEventSource(this.event);
  }

  private setEventSource = (event: VeritasMessage) => {
    this.eventDetail$ = this.dumpsterService
      .getDumpsterEventDetail({
        service: event.service,
        supplier: event.supplier,
        entityId: event.entityId,
        id: event.transactionId,
      })
      .subscribe({
        next: (event: VeritasMessage) => { this.eventSource = event; },
        error: () => { this.eventSource = null; }
      });
  }
}

export interface DumpsterEventDetailDialogInput extends IDialogInput {
  event: VeritasMessage,
  payloadTypes: PayloadType[],
  wasteTypes: WasteType[]
}
